import React from 'react';
import GovLetterPage, { fleetCarRows } from './GovLetterPage';

const PAGE = {
    storageKey: 'YELO_HIAZA_DATA',
    title: 'Hiaza (حيازة)',
    detailsTitle: 'Hiaza Details',
    form: {
        title: 'حيازة مركبة',
        toAddress: 'السادة هيئة الطرق والمواصلات                المحترمين',
        toCity: 'دبي -الامارات العربية المتحدة',
        introStatic: 'نحيط سيادتكم علما نحن شركة الوفاق السعودية لتأجير السيارات ذ م م رخصة تجارية رقم 559385 بصفتنا مالكين المركبة المذكورة مواصفاتها لاحقا بانه لا مانع لدينا من حيازة ملكية المركبة لصالح   ',
        introDynamic: '',
        shippingNote: ''
    },
    fields: [
        { key: 'date', label: 'Date', rtl: false },
        { key: 'title', label: 'Document Title' },
        { key: 'introDynamic', label: 'Details (Person/Entity)', full: true, rows: 3, placeholder: '[ادخل اسم الشخص أو الجهة هنا]' },
    ],
    pdfName: 'Vehicle_Hiaza_',
    pageId: 'hiaza-page-',
    letter: {
        intro: (f) => <>{f.introStatic}{f.introDynamic}</>,
        rows: fleetCarRows,
    },
};

const Hiaza = (props) => <GovLetterPage page={PAGE} {...props} />;

export default Hiaza;
